import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	yourData: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-lozenge.your-data',
		defaultMessage: 'Your data',
		description:
			'This lozenge text is displayed when the intent template was generated from existing data',
	},
	catalog: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-lozenge.catalog',
		defaultMessage: 'Catalog',
		description:
			'This lozenge text is displayed when the intent template is part of the catalog of templates',
	},
});
